(function () {
  if (window.__intOOM) return;

  var el = document.getElementById('int-oom-data');
  if (!el) return;

  var CODES = String(el.getAttribute('data-countries') || '')
                .split(',').map(function (s) { return s.trim().toUpperCase(); })
                .filter(Boolean);
  var HOME  = String(el.getAttribute('data-home') || '').toUpperCase();
  var COPY  = {};
  try { COPY = JSON.parse(el.textContent || '{}'); } catch (e) { return; }

  /* ⚠️ Shopify's `t` filter HTML escapes the locale value, so "don't" arrives
     here as "don&#39;t". Decode once, on read, so the strings are plain text
     from this point on and esc() below is the only thing that escapes them.
     Without this the visitor reads a literal "don&#39;t" in the notice.
     A textarea decodes entities without executing anything. */
  (function () {
    var ta = document.createElement('textarea');
    Object.keys(COPY).forEach(function (k) {
      if (typeof COPY[k] !== 'string') return;
      ta.innerHTML = COPY[k];
      COPY[k] = ta.value;
    });
  })();

  /* Nothing derived, nothing to compare against: stay silent. */
  if (!CODES.length) return;

  var KEY = 'int_oom_v1';
  function ssGet(k) { try { return sessionStorage.getItem(k); } catch (e) { return null; } }
  function ssSet(k, v) { try { sessionStorage.setItem(k, v); } catch (e) {} }

  var settle;
  var ready = new Promise(function (res) { settle = res; });
  window.__intOOM = { ready: ready, copy: COPY };

  function esc(s) {
    return String(s).replace(/&/g, '&amp;').replace(/</g, '&lt;')
                    .replace(/>/g, '&gt;').replace(/"/g, '&quot;');
  }

  /* The sentence, assembled from tokens. The locale string carries no HTML. */
  function noticeHtml(name) {
    return esc(COPY.notice || '')
      .replace('[country]', esc(name))
      .replace('[wishlist]',
        '<a class="int-oom__link" href="' + esc(COPY.wishlistUrl || '/pages/swym-wishlist') + '">'
        + esc(COPY.wishlistWord || 'wishlist') + '</a>')
      .replace('[newsletter]',
        '<a class="int-oom__link" href="#" data-int-oom-newsletter>'
        + esc(COPY.newsletterWord || 'newsletter') + '</a>');
  }
  window.__intOOM.noticeHtml = noticeHtml;

  function decide(code, name) {
    if (!code) return null;
    code = String(code).toUpperCase();
    if (CODES.indexOf(code) !== -1) return null;   /* in one of our markets */
    if (HOME && code === HOME) return null;        /* Shopify put them here itself */
    return { code: code, name: name || code };
  }

  var STATE = null;
  function finish(v) {
    STATE = v;
    settle(v);
    if (v) startNotices();
  }

  /* The cache is read SYNCHRONOUSLY, on parse. Only the network call is
     deferred. ⚠️ This ordering matters: the region card waits on this promise
     with a cap, and if the cache read sat behind requestIdleCallback the card
     could time out and paint the ordinary "Shipping to Denmark" content to a
     visitor in Australia on the second and every later page of the visit.
     Reproduced 2026-09-03 when the read was inside the idle callback.
     Returns true when it answered, so the caller knows to skip the fetch. */
  function readCache() {
    var cached = ssGet(KEY);
    if (cached === null) return false;
    if (cached === '') { finish(null); return true; }
    try { var o = JSON.parse(cached); finish(decide(o.c, o.n)); return true; } catch (e) {}
    return false;
  }

  function load() {
    if (readCache()) return;
    if (typeof fetch !== 'function') return finish(null);

    var ctl = null, timer = null;
    try { ctl = new AbortController(); } catch (e) {}
    var opts = { credentials: 'same-origin' };
    if (ctl) { opts.signal = ctl.signal; timer = setTimeout(function () { try { ctl.abort(); } catch (e) {} }, 5000); }

    fetch('/browsing_context_suggestions.json', opts)
      .then(function (r) { if (!r.ok) throw 0; return r.json(); })
      .then(function (d) {
        clearTimeout(timer);
        var dv = d && d.detected_values;
        var c  = dv && dv.country;
        var code = (c && c.handle) ? String(c.handle).toUpperCase() : '';
        var name = (c && c.name) || (dv && dv.country_name) || '';
        if (!code) { ssSet(KEY, ''); return finish(null); }
        ssSet(KEY, JSON.stringify({ c: code, n: name }));
        finish(decide(code, name));
      })
      .catch(function () { clearTimeout(timer); finish(null); });
  }

  /* Lazy and off the critical path. Idle, with a backstop, so the region card
     (which is itself gated behind the consent banner plus 650ms) is not left
     waiting on this. */
  function kick() {
    if (readCache()) return;
    if ('requestIdleCallback' in window) requestIdleCallback(load, { timeout: 1500 });
    else setTimeout(load, 400);
  }
  /* Answer from cache before anything is scheduled, so every page after the
     first in a visit resolves in the same tick as this script. */
  if (!readCache()) {
    if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', kick, { once: true });
    else kick();
  }

  /* ====================================================
     SURFACE 2, THE CART DRAWER
     Mounted as the FIRST child of .rebuy-cart__body, which is the scrolling
     content area. It is nowhere near .rebuy-cart__footer, where the subtotal,
     the checkout button, the express buttons and the discount field live, and
     it touches none of them.
     The drawer is Vue rendered, so it re-paints and can drop a foreign node.
     A childList observer puts it back. The observer's own insert is a no-op on
     the next pass because the node is then present, so it cannot loop.
     ==================================================== */
  var CART_ROOT = '#drawer-cart';
  var mo = null;

  /* ====================================================
     INT 2026-09-04 · THE THIRD AND FOURTH SURFACES.
     Settled live on the draft the same day, and it changed the design:

       GET /cart returns 200, body class `template-cart`, and the served HTML
       DOES contain a working name="checkout" button. In a browser with
       JavaScript the theme immediately sends /cart to /?viewcart=true and opens
       the Smart Cart, so `location` reads /?viewcart=true, the body class reads
       template-index, and there is no checkout control anywhere outside the
       drawer. Both states measured, minutes apart, on the same cart.

     So for a normal visitor Nils is right, the Smart Cart is the only route to
     checkout, and the drawer note already sits on it. Two gaps remain:

       1. THE PRODUCT PAGE. The drawer note only arrives after the visitor has
          chosen something and opened the cart. Saying it on the product page
          costs them one less step and one less disappointment.
       2. THE SERVER CART PAGE. If the redirect never runs, no JavaScript, a
          script error, a slow third party, the visitor lands on a real cart
          page with a real Check Out button and, until now, no notice at all.

     Neither mount blocks, hides or disables anything, same rule as the drawer.
     Both are idempotent and both are re-inserted by the existing observer, so a
     variant change or a section re-render cannot drop them permanently.
     ==================================================== */

  function buildNote(id, extraClass) {
    var n = document.createElement('div');
    n.className = 'int-oom-note' + (extraClass ? ' ' + extraClass : '');
    n.id = id;
    n.setAttribute('role', 'status');
    n.innerHTML = noticeHtml(STATE.name);
    return n;
  }

  /* Where the note goes, in order of preference. Measured live 2026-09-03 on
     this store: Rebuy does NOT render .rebuy-cart__body here, and the drawer's
     scrolling area carries no Rebuy class of its own, so the reliable anchor is
     .rebuy-cart__title. The note is placed immediately AFTER the header block
     that holds it, which is under the logo and above the first line item, and a
     long way from .rebuy-cart__checkout-button and the express buttons. */
  function mountPoint(root) {
    var nativeBody = root.querySelector('.int-cart-body, .drawer__body');
    if (nativeBody) return { parent: nativeBody, before: nativeBody.firstChild };
    return { parent: root, before: root.firstChild };
  }

  function insertNote() {
    if (!STATE) return;
    if (document.getElementById('int-oom-cart-note')) return;
    var root = document.querySelector(CART_ROOT);
    if (!root) return;
    var m = mountPoint(root);
    if (!m || !m.parent) return;
    m.parent.insertBefore(buildNote('int-oom-cart-note'), m.before);
  }

  /* SURFACE 3, the product page. Anchors measured live 2026-09-04 on a framed
     print PDP: the buy button sits in
     .product__quantity-and-cart > product-form.product__block__buttons >
     form.shopify-product-form > .product__form__inner > .product__submit.
     The note goes ABOVE that whole block, never between the variant picker and
     the button, and never inside the form. */
  function insertPdpNote() {
    if (!STATE) return;
    if (!document.body || !document.body.classList.contains('template-product')) return;
    if (document.getElementById('int-oom-pdp-note')) return;
    var anchor = document.querySelector('product-form.product__block__buttons')
              || document.querySelector('.product__submit');
    if (anchor && anchor.parentElement) {
      anchor.parentElement.insertBefore(buildNote('int-oom-pdp-note', 'int-oom-note--pdp'), anchor);
      return;
    }
    var wrap = document.querySelector('.product__quantity-and-cart');
    if (wrap) wrap.insertBefore(buildNote('int-oom-pdp-note', 'int-oom-note--pdp'), wrap.firstChild);
  }

  /* SURFACE 4, the server rendered cart page. Only reachable when the redirect
     to the Smart Cart has not run. The note goes at the TOP of the cart form,
     nowhere near the Check Out button, which keeps working. */
  function insertCartPageNote() {
    if (!STATE) return;
    if (!document.body || !document.body.classList.contains('template-cart')) return;
    if (document.getElementById('int-oom-cartpage-note')) return;
    var form = null;
    var forms = document.querySelectorAll('form[action*="/cart"]');
    for (var i = 0; i < forms.length; i++) {
      if (forms[i].querySelector('[name="checkout"]')) { form = forms[i]; break; }
    }
    var target = form || document.getElementById('MainContent');
    if (!target) return;
    target.insertBefore(buildNote('int-oom-cartpage-note', 'int-oom-note--cart'), target.firstChild);
  }

  /* One call site for all three, so nothing can be added later and forgotten. */
  function insertAllNotes() {
    insertNote();
    insertPdpNote();
    insertCartPageNote();
  }

  function startNotices() {
    if (mo) return;
    ['theme:cart:change', 'theme:cart:reload'].forEach(function (ev) {
      document.addEventListener(ev, function () { setTimeout(insertAllNotes, 0); setTimeout(insertAllNotes, 350); });
    });
    var nativeDrawer = document.querySelector('#drawer-cart');
    if (nativeDrawer) nativeDrawer.addEventListener('theme:drawer:open', function () { setTimeout(insertAllNotes, 0); });
    /* Throttled. The drawer is Vue rendered and can drop a foreign node, so the
       observer is the thing that puts it back, but an unthrottled body wide
       subtree observer would run a querySelector on every mutation of a busy
       page. 120ms is far below anything a person can see and caps the work.
       None of this exists for an in market visitor: startNotices is only
       ever called once STATE is set. */
    var pending = false;
    function scheduleInsert() {
      if (pending) return;
      pending = true;
      setTimeout(function () { pending = false; insertAllNotes(); }, 120);
    }
    try {
      mo = new MutationObserver(scheduleInsert);
      mo.observe(document.body, { childList: true, subtree: true });
    } catch (e) {}
    insertAllNotes();
    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', insertAllNotes, { once: true });
    }
  }

  /* The newsletter word goes to the footer signup, on either surface. */
  document.addEventListener('click', function (e) {
    var a = e.target && e.target.closest ? e.target.closest('[data-int-oom-newsletter]') : null;
    if (!a) return;
    e.preventDefault();
    try {
      if (typeof window.__intCloseCartDrawer === 'function') window.__intCloseCartDrawer();
    } catch (err) {}
    var card = document.getElementById('int-region-card');
    if (card && card.classList.contains('is-visible') && typeof window.__intRegionCardDismiss === 'function') {
      window.__intRegionCardDismiss();
    }
    setTimeout(function () {
      var form  = document.querySelector('.iq-signup');
      var input = form && form.querySelector('input[type="email"], input[name="contact[email]"]');
      var target = form || input;
      if (!target) return;
      try { target.scrollIntoView({ behavior: 'smooth', block: 'center' }); } catch (err) { target.scrollIntoView(); }
      if (input) setTimeout(function () { try { input.focus({ preventScroll: true }); } catch (err) {} }, 700);
    }, 260);
  }, false);
})();
